import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./i18n";
import SmoothScroll from "./components/layout/SmoothScroll";

import Home from "./pages/Home";
import { ProceduresHub, CategoryHub } from "./pages/Hubs";
import { GuidesHub, PatientJourneyPage, AboutPage, ContactPage } from "./pages/StaticPages";
import { ResultsPage } from "./pages/InfoPages";
import { PrivacyPolicy, Terms, MedicalDisclaimer, ImageConsentPolicy, CookiePolicy } from "./pages/Legal";
import { EditorialPolicy } from "./pages/StaticPages";
import SeoContentPage from "./templates/SeoContentPage";
import { SEO_PAGES } from "./data/seo";
import { DoctorReviewPage, AftercarePage } from "./pages/NewPages";
import { SLUG_MAP } from "./data/localizedRoutes";
import SlugResolver from "./pages/SlugResolver";
import NotFound from "./pages/NotFound";
import { PROCEDURE_CATEGORIES } from "./data/procedures";

const seo = (slug) => <SeoContentPage page={SEO_PAGES[slug]} />;

// All inner routes (relative — mounted under each language prefix).
function AppRoutes({ lang }) {
  return (
    <Routes>
      <Route index element={<Home />} />

      {/* New: language-specific slugs for Doctor Review + Aftercare */}
      <Route path={SLUG_MAP.doctorReview[lang]} element={<DoctorReviewPage />} />
      <Route path={SLUG_MAP.aftercare[lang]} element={<AftercarePage />} />

      {/* Hubs */}
      <Route path="procedures" element={<ProceduresHub />} />
      <Route path="guides" element={<GuidesHub />} />
      <Route path="patient-journey" element={<PatientJourneyPage />} />
      <Route path="results" element={<ResultsPage />} />
      <Route path="about" element={<AboutPage />} />
      <Route path="contact" element={<ContactPage />} />
      <Route path="editorial-policy" element={<EditorialPolicy />} />

      {/* Priority SEO content pages */}
      <Route path="plastic-surgery-cost-vietnam" element={seo("plastic-surgery-cost-vietnam")} />
      <Route path="plastic-surgery-safety-vietnam" element={seo("plastic-surgery-safety-vietnam")} />
      <Route path="how-to-choose-a-plastic-surgeon-in-vietnam" element={seo("how-to-choose-a-plastic-surgeon-in-vietnam")} />
      <Route path="revision-plastic-surgery-vietnam" element={seo("revision-plastic-surgery-vietnam")} />
      <Route path="facelift-vietnam" element={seo("facelift-vietnam")} />
      <Route path="breast-augmentation-vietnam" element={seo("breast-augmentation-vietnam")} />
      <Route path="nose-surgery-vietnam" element={seo("nose-surgery-vietnam")} />
      <Route path="asian-rhinoplasty-vietnam" element={seo("asian-rhinoplasty-vietnam")} />
      <Route path="revision-rhinoplasty-vietnam" element={seo("revision-rhinoplasty-vietnam")} />

      {/* Category hubs (revision + nose have their own SEO pages above) */}
      {PROCEDURE_CATEGORIES.filter((c) => c.slug !== "revision-plastic-surgery-vietnam" && c.slug !== "nose-surgery-vietnam").map((c) => (
        <Route key={c.slug} path={c.slug} element={<CategoryHub categorySlug={c.slug} />} />
      ))}

      {/* Legal */}
      <Route path="privacy-policy" element={<PrivacyPolicy />} />
      <Route path="terms" element={<Terms />} />
      <Route path="medical-disclaimer" element={<MedicalDisclaimer />} />
      <Route path="image-consent-policy" element={<ImageConsentPolicy />} />
      <Route path="cookie-policy" element={<CookiePolicy />} />

      {/* Dynamic: procedures + guides (static routes above take precedence) */}
      <Route path=":slug" element={<SlugResolver />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function Localized({ lang }) {
  return (
    <LanguageProvider lang={lang}>
      <SmoothScroll>
        <AppRoutes lang={lang} />
      </SmoothScroll>
    </LanguageProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/fr/*" element={<Localized lang="fr" />} />
        <Route path="/de/*" element={<Localized lang="de" />} />
        <Route path="/*" element={<Localized lang="en" />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}
